<template>
  <div id="ReportCanceledTransactions">
    <TitleReportsCard
      title="Transacciones canceladas"
      :loading="loading"
      @generateReport="generateReport"
    >
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <InputDatePickerReport
          v-model="dateStart"
          :newMax="dateEnd"
          label="Seleccione una fecha de inicio"
          :disabled="loading"
          @change="generated = false"
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <InputDatePickerReport
          v-model="dateEnd"
          label="Seleccione una fecha de fin"
          :disabled="loading"
          @change="generated = false"
        />
      </v-col>
      <v-col
        cols="12"
        sm="12"
        md="6"
      >
        <v-select
          v-model="placeSelected"
          prepend-icon="mdi-bank"
          dense
          outlined
          :items="placesForUser"
          name="id"
          item-text="name"
          item-value="id"
          label="Seleccione un parador"
          background-color="white"
          :disabled="loading"
          @change="generated = false"
        />
      </v-col>
    </TitleReportsCard>

    <ContentReportsCard
      :loading="loading"
      :generated="generated"
      :fileName="fileName"
      :noData="!transactionsDetails.length"
    >
      <ReportCanceledTransactionsTable
        :dateStart="dateStart"
        :dateEnd="dateEnd"
        :titleReport="getTitleReport"
        :transactionsDetails="transactionsDetails"
        :toltalCancelations="toltalCancelations"
      />
    </ContentReportsCard>
  </div>
</template>

<script>
import { mapState } from 'vuex'

// Components
import TitleReportsCard from '../tools/reports/TitleReportsCard.vue'
import InputDatePickerReport from '../tools/reports/InputDatePickerReport.vue'
import ContentReportsCard from '../tools/reports/ContentReportsCard.vue'
import ReportCanceledTransactionsTable from './ReportCanceledTransactionsTable.vue'

export default {
  name: 'ReportCanceledTransactions',
  components: { TitleReportsCard, InputDatePickerReport, ContentReportsCard, ReportCanceledTransactionsTable },
  data () {
    return {
      dateStart: '',
      dateEnd: '',
      loading: false,
      generated: false,
      placeSelected: null,
      transactionsDetails: [],
      toltalCancelations: 0
    }
  },
  computed: {
    ...mapState('dashboard', ['placesForUser']),
    namePlaceSelected: function () {
      let name = ''
      this.placesForUser.forEach(element => {
        if (element.id === this.placeSelected) name = element.name
      })
      return name
    },
    fileName: function () {
      return 'Transacciones_canceladas_' + this.namePlaceSelected + '_del_' + this.dateStart + '_hasta_' + this.dateEnd
    },
    getTitleReport: function () {
      return `Transacciones canceladas de "${this.namePlaceSelected}"`
    }
  },
  mounted () {
    this.dateStart = this.$sumarDias(new Date(), -1)
    this.dateEnd = this.$sumarDias(new Date(), -1)
  },
  methods: {
    generateReport: function () {
      if (!this.placeSelected) {
        this.$swalAlert('warning', 'Seleccione un parador!')
        return
      }

      this.transactionsDetails = []
      this.toltalCancelations = 0
      this.loading = true
      this.generated = false

      const data = {
        dateStart: this.dateStart,
        dateEnd: this.dateEnd,
        placeSelected: this.placeSelected
      }
      this.$root.post('/reports/canceledTransactions', data)
        .then(response => {
          const data = response.data
          if (data?.success === 'FALSE') {
            this.$swalAlert('error', null, data.message)
            return
          }

          const info = data?.[0] || []
          let toltalCancelations = 0

          this.transactionsDetails = info.map(element => {
            toltalCancelations += Number(element.total) || 0
            element.details = JSON.parse(element.details)
            return element
          })
          this.toltalCancelations = toltalCancelations
        })
        .finally(() => {
          this.loading = false
          this.generated = true
        })
    }
  }
}
</script>

<style>

</style>
